/* Mesure d'audience interne : compteurs anonymes, sans cookie ni identifiant. */
const sent = new Set();

export function track(event, once = false) {
  if (once) {
    if (sent.has(event)) return;
    sent.add(event);
  }
  const payload = JSON.stringify({ e: event, p: location.pathname });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/evenement', new Blob([payload], { type: 'application/json' }));
    } else {
      fetch('/evenement', { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'application/json' } });
    }
  } catch { /* la mesure ne doit jamais gêner la navigation */ }
  window.dispatchEvent(new CustomEvent('jg:track', { detail: { event } }));
}

export function initTracking() {
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-track]');
    if (el) track(el.dataset.track);
  });
}
